import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { stripHtmlTags } from "@msys/common";
import { Box, Card, CardActionArea, CardActions, CardContent, CardMedia, Stack, Typography, } from "@mui/material";
import React from "react";
import { GalleryModal } from "./gallery/GalleryModal.js";
import { useScreenWidth } from "./hooks/useScreenWidth.js";
import { ModalOpenProcess, } from "./modal/ModalOpenProcess.js";
import defaultImageUrl from "../assets/no-image.png";
import { TypographyWithMaxNumberOfLines } from "./text/Typography.js";
export const MediaCardItem = ({ imageUrl = defaultImageUrl, ActionButton, StatusIcons, Info, Tags, title, brand, article, description, price, onClick, size: sizeProp, descriptionMaxNumberOfLines, images, selected = false, ...props }) => {
    const { isMinTablet } = useScreenWidth();
    const size = sizeProp ?? (isMinTablet ? "medium" : "small");
    const processRef = React.useRef();
    return (_jsxs(Card, { ...props, sx: {
            display: "flex",
            flexDirection: "column",
            position: "relative",
            textDecoration: "none",
            height: "100%",
            ...(selected
                ? {
                    borderWidth: 1,
                    borderColor: "secondary.main",
                }
                : undefined),
            ...props.sx,
        }, children: [_jsx(CardMedia, { sx: {
                    position: "relative",
                    width: "100%",
                    // aspectRatio: "4 / 3", // Not supported on Safari < 15 https://caniuse.com/mdn-css_properties_aspect-ratio
                    paddingTop: "75%",
                    cursor: (images && images.length > 0) || onClick ? "pointer" : "default",
                }, image: imageUrl, onClick: images && images.length > 0
                    ? e => {
                        e.preventDefault();
                        e.stopPropagation();
                        processRef.current?.open();
                    }
                    : onClick, children: ActionButton ? (_jsx(CardActions, { sx: {
                        position: "absolute",
                        right: 0,
                        top: 0,
                    }, onMouseDown: e => {
                        e.stopPropagation();
                    }, onTouchStart: e => {
                        e.stopPropagation();
                    }, onClick: e => {
                        e.preventDefault();
                        e.stopPropagation();
                    }, children: _jsx(Stack, { direction: "row", spacing: 0.5, alignItems: "center", flexShrink: 0, flexGrow: 0, children: ActionButton }) })) : null }), _jsx(CardActionArea, { disableRipple: true, onClick: onClick, sx: { flex: 1 }, children: _jsxs(CardContent, { sx: {
                        padding: size === "medium" ? "8px 12px" : "4px 8px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        width: "100%",
                        height: "100%",
                        minWidth: 0,
                        gap: 0.5,
                    }, children: [brand && (_jsx(Typography, { variant: "body2", fontWeight: "bold", children: brand })), title || StatusIcons ? (_jsxs(Stack, { direction: "row", spacing: 0, justifyContent: "space-between", alignItems: "flex-start", children: [_jsx(TypographyWithMaxNumberOfLines, { "$maxLines": 2, variant: size === "medium" ? "h2" : "h3", children: title }), StatusIcons ? (_jsx(Stack, { direction: "row", spacing: 0.5, alignItems: "center", flexShrink: 0, flexGrow: 0, height: 22, children: StatusIcons })) : null] })) : null, description ? (_jsx(TypographyWithMaxNumberOfLines, { "$maxLines": descriptionMaxNumberOfLines ?? (size === "medium" ? 3 : 1), variant: "body2", children: stripHtmlTags(description, true) })) : null, article && (_jsx(Typography, { variant: "body2", sx: { color: "grey.600" }, noWrap: true, children: article })), Info ? (_jsx(Box, { maxHeight: "76px", overflow: "hidden", children: Info })) : null, Tags ? (_jsx(Box, { maxHeight: "76px", overflow: "hidden", children: Tags })) : null, price ? (_jsx(Typography, { variant: "body1", align: "left", children: price })) : null] }) }), images && (_jsx(ModalOpenProcess, { ref: processRef, Modal: GalleryModal, modalProps: {
                    images,
                } })), selected && (_jsx(Box, { sx: {
                    position: "absolute",
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    userSelect: "none",
                    pointerEvents: "none",
                    outline: 2,
                    outlineColor: "secondary.main",
                    outlineOffset: -1,
                } }))] }));
};
//# sourceMappingURL=MediaCardItem.js.map